import { NotificationDto } from 'types/Notification';

export enum RealtimeAudienceEnum {
  HubStateUpdated = 'ExpertHubStateUpdated',
  NotificationInserted = 'ExpertNotificationInserted',
  JobOrderApplicationStatusUpdated = 'ExpertJobOrderApplicationStatusUpdated',
  AirPrepping = 'ExpertAirPrepping',
}

export type RealtimeAudienceParams = {
  [RealtimeAudienceEnum.HubStateUpdated]: { expertId: string };
  [RealtimeAudienceEnum.NotificationInserted]: { expertId: string };
  [RealtimeAudienceEnum.JobOrderApplicationStatusUpdated]: { expertId: string };
  [RealtimeAudienceEnum.AirPrepping]: { expertId: string };
};

export type RealtimeMessageMap = {
  [RealtimeAudienceEnum.HubStateUpdated]: { state: string; updatedAt: string };
  [RealtimeAudienceEnum.NotificationInserted]: { notification?: NotificationDto };
  [RealtimeAudienceEnum.JobOrderApplicationStatusUpdated]: { jobOrderId: string };
  // ready for other event types
  [RealtimeAudienceEnum.AirPrepping]: { preppingId: string; event: 'Deleted' };
};
